class CollectionLoadMore {
  constructor() {
    this.loadMoreButton = document.querySelector('[data-load-more]');
    this.productGrid = document.querySelector('#product-grid');
    this.loadingSpinner = document.querySelector('.collection__loading-spinner');
    
    if (this.loadMoreButton) {
      this.init();
    }
  }

  init() {
    if (this.loadMoreButton) {
      this.loadMoreButton.style.display = 'none';
    }

    this.enableInfiniteScroll();
  }

  async loadMoreProducts() {
    const currentUrl = new URL(window.location.href);
    const currentPage = parseInt(currentUrl.searchParams.get('page') || '1');
    const nextPage = currentPage + 1;

    if (this.loadMoreButton) {
      this.loadMoreButton.classList.add('hidden');
    }
    if (this.loadingSpinner) {
      this.loadingSpinner.classList.remove('hidden');
    }

    try {
      currentUrl.searchParams.set('page', nextPage);
      const response = await fetch(currentUrl.toString());
      const html = await response.text();
      
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      
      const newProducts = doc.querySelectorAll('#product-grid > li');
      
      if (newProducts.length > 0) {
        newProducts.forEach(product => {
          this.productGrid.appendChild(product);
        });
        
        window.history.pushState({}, '', currentUrl.toString());

        const loadMoreButtonInNewPage = doc.querySelector('[data-load-more]');
        if (!loadMoreButtonInNewPage) {
          if (this.observer) {
            this.observer.disconnect();
          }
          if (this.sentinel) {
            this.sentinel.remove();
          }
        }
      } else {
        if (this.observer) {
          this.observer.disconnect();
        }
        if (this.sentinel) {
          this.sentinel.remove();
        }
      }
    } catch (error) {
      console.error('Error loading more products:', error);
      if (this.loadingSpinner) {
        this.loadingSpinner.innerHTML = '<p style="color: #999;">Unable to load more products</p>';
      }
    } finally {
      if (this.loadingSpinner) {
        this.loadingSpinner.classList.add('hidden');
      }
    }
  }

  enableInfiniteScroll() {
    const sentinel = document.createElement('div');
    sentinel.className = 'collection__scroll-sentinel';
    sentinel.style.height = '1px';
    this.productGrid.parentNode.appendChild(sentinel);

    let isLoading = false;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !isLoading) {
          isLoading = true;
          this.loadMoreProducts().then(() => {
            isLoading = false;
          });
        }
      });
    }, {
      rootMargin: '400px'
    });

    observer.observe(sentinel);
    this.sentinel = sentinel;
    this.observer = observer;
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionLoadMore();
  });
} else {
  new CollectionLoadMore();
}
